import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";

export const adEffectivenessApi = createApi({
    reducerPath:"adEffectivesnesApi",
    baseQuery:axiosBaseQuery(),
    endpoints:(builder)=>({
        getAdTableData: builder.mutation({
            query:(payload: any)=>({
               url:"/adEffectivenessTableData",
               method:"POST",
               data:payload 
            })
        }),
        getAdEffectivenessDropdownFilter: builder.mutation({
            query:(payload: any)=>({
                url:"/adEffectivenessDropdownFilter",
                method: "POST",
                data: payload,
            })
        })
    })
})

export const { 
    useGetAdTableDataMutation,
    useGetAdEffectivenessDropdownFilterMutation,
}  = adEffectivenessApi;